<template>
  <Modal :open="open" @close="$emit('close')">
    <div v-if="selection">
      <h2 class="text-lg font-bold text-gray-900">{{ t("title") }}</h2>
      <p class="mt-1 text-sm text-gray-500">
        {{ t("subtitle", { store: selection.storeName, module: selection.moduleTitle }) }}
      </p>
      <p class="mt-3 text-sm font-semibold text-gray-700">
        {{ t("summary", { passed: selection.cell.passedCount, total: selection.cell.totalSellers }) }}
      </p>

      <ul v-if="sellers.length" class="mt-4 divide-y divide-gray-100 border-t border-b border-gray-100">
        <li v-for="seller in sellers" :key="seller.id" class="flex items-center justify-between py-2.5">
          <span class="text-sm font-medium text-gray-900">{{ seller.name }}</span>
          <span class="text-xs text-gray-500">
            <template v-if="seller.lastAttemptAt">
              {{ t("last_attempt", { date: formatDate(seller.lastAttemptAt), score: seller.scorePercent }) }}
            </template>
            <template v-else>{{ t("no_attempt") }}</template>
          </span>
        </li>
      </ul>
      <p v-else-if="selection.cell.totalSellers === 0" class="mt-4 text-sm text-gray-500">{{ t("no_sellers") }}</p>
      <p v-else class="mt-4 text-sm text-gray-500">{{ t("all_trained") }}</p>

      <div class="mt-6 flex justify-end">
        <SecondaryButton @click="$emit('close')">{{ t("close") }}</SecondaryButton>
      </div>
    </div>
  </Modal>
</template>

<script>
import { Modal, SecondaryButton } from "@estaly/ui";
import { useI18n } from "vue-i18n";

export default {
  name: "NotTrainedSellersModal",
  components: { Modal, SecondaryButton },
  props: {
    open: { type: Boolean, default: false },
    // { storeName, moduleTitle, cell: { passedCount, totalSellers, notPassedSellers } }
    selection: { type: Object, default: null },
  },
  emits: ["close"],
  setup() {
    const { t, locale } = useI18n();
    return { t, locale };
  },
  computed: {
    sellers() {
      return this.selection?.cell?.notPassedSellers || [];
    },
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleDateString(this.locale);
    },
  },
};
</script>

<i18n src="./NotTrainedSellersModal.i18n.json"></i18n>
